var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileStack2Layer3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 380 285",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0969 0 0 1.1128 3.4773 12.793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.137 147.47c-25.997-16.691-13.812-45.426 5.1653-52.434-16.872-19.7 9.3602-34.711 22.991-32.468-0.45-22.319 41.708-27.291 56.549-14.925-0.511-25.363 47.099-32.756 62.686-9.9837 35.491-20.702 86.816 6.7482 71.149 28.754 12.376-9.9101 27.065-3.9163 33.859 8.6234 18.385-8.2768 51.845 4.7872 36.288 32.208 16.182 3.589 9.978 33.269 0.675 33.471 13.034 16.953-19.658 41.969-32.097 31.582 0.459 22.777-33.656 27.623-53.019 15.356-17.204 20.163-53.583 12.323-57.902-2.299-15.462 14.619-24.888 12.405-42.242 0.914-31.168 19.207-89.196-1.696-76.867-19.65-20.529 4.835-34.406-11.607-27.235-19.149z",
    fill: "#4fc3ea",
    strokeWidth: 0.81926
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.7616
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.68 66.417c15.667-22.006-35.658-49.456-71.149-28.754-15.587-22.772-63.197-15.38-62.686 9.9837-7.694-6.4109-22.73-8.1617-35.364-5.2515m220.09 30.484c15.913 2.0388 30.59 14.395 19.258 34.369 16.182 3.589 9.978 33.269 0.675 33.471 8.936 11.623-3.622 27.037-16.41 32.232m-268.27-101.84c-5.7432 5.9153-7.7022 14.368 0.4823 23.925-18.978 7.0075-31.162 35.742-5.1653 52.434-4.2732 4.495-2.6756 11.427 4.9533 15.856m31.026 21.383c16.258 9.583 47.864 14.044 68.123 1.56 17.354 11.491 26.78 13.705 42.242-0.914 4.319 14.622 40.698 22.462 57.902 2.299 11.299 7.158 27.62 8.489 39.164 3.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.96 55.726 18.646-29.456m-1.892 29.946 25.275-24.649m-21.742 39.486 29.476-17.851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.034 168.45-18.647 29.457m1.8923-29.946-25.275 24.649m21.742-39.485-29.476 17.851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.15 59.684-19.818-28.624m3.0976 29.838-26.246-23.534m23.315 38.51-30.17-16.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.48 180.47 19.817 28.624m-3.097-29.838 26.246 23.534m-23.315-38.51 30.171 16.56"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStack2Layer3);
export default __webpack_public_path__ + "static/media/mobile_stack2_layer3.e941d4bfbbc88f07e6a451c19376ee9a.svg";
export { ForwardRef as ReactComponent };